
export enum CommServerRequestState {
    Pending,
    Requested,
    Completed,
    Expired,
    Cancelled
}
